import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    fontSize: 14,
    fontWeight: 600,
    color: 'var(--color-colorprimary-dark-5)',
    lineHeight: '16.9px',
    letterSpacing: 0,
  },
}));

const Label = ({ label = '' }) => {
  const classes = useStyles();

  return <div className={`${classes.root} underlying-label`}>{label}</div>;
};

export default Label;
